export const toolkitTestIds = {
    assetSelectTrigger: "asset-select-trigger",
    autoSizeFractionInput: {
        container: "auto-size-input-container",
        input: "auto-size-input",
        endAdornment: "auto-size-input-end-adornment",
    },
    balance: { container: "balance", usdValue: "balance-usd-value" },
    button: "button",
    calendar: {
        title: "calendar-title",
    },
    collapsible: {
        content: "collapsible-content",
    },
    dateTimePicker: {
        invalidDateIcon: "invalid-date-icon",
        rangeCalendar: {
            title: "range-calendar-title",
        },
        timeField: {
            label: "time-picker-label",
        },
    },
    dateI18n: "date-i18n",
    delta: "delta",
    dialog: {
        container: "dialog-container",
    },
    dropdown: {
        container: "dropdown-container",
        item: "dropdown-item",
        trigger: "dropdown-trigger",
    },
    heading: "heading",
    hovercard: {
        trigger: "hovercard-trigger",
        content: "hovercard-content",
    },
    notice: {
        success: "notice-success",
        error: "notice-error",
        warning: "notice-warning",
        info: "notice-info",
    },
    numberI18n: "number-i18n",
    percentage: "percentage",
    popover: {
        trigger: "popover-trigger",
        content: "popover-content",
    },
    select: {
        container: "select-container",
        item: "select-item",
    },
    tabs: {
        trigger: "tabs-trigger",
        content: "tabs-content",
    },
    text: "rich-text",
    tooltip: {
        trigger: "tooltip-trigger",
        content: "tooltip-content",
    },
    walletConnectDialog: {
        container: "wallet-connect-dialog-container",
    },
};
//# sourceMappingURL=testIds.js.map